import { Component } from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";

import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {GridApi, GridOptions} from "ag-grid-community";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {DelinquencyReportService} from "../../../services/delinquency-report/delinquency-report.service";
import {LoadingService} from "../../../services/loading/loading.service";
import {AlertService} from "../../../services/alert/alert.service";
import moment from "moment/moment";
import {
  ConfirmationModalComponent
} from "../../../shared/common-components/confirmation-modal/confirmation-modal.component";
import {CommonHelpers} from "../../../shared/common-helpers";
import AppConstants from "../../../shared/common-components/AppConstants";
import {CellRenderer} from "../../delinquency-report/cell-rendering/cell-renderer.component";
import {IconRenderer} from "../../delinquency-report/cell-rendering/icon-renderer.component";

@Component({
    selector: 'app-xtos-delinquency-reporting',
    imports: [
    AgGridAngular,
    ReactiveFormsModule
],
    templateUrl: './xtos-delinquency-reporting.component.html',
    styleUrl: './xtos-delinquency-reporting.component.css'
})
export class XtosDelinquencyReportingComponent {
  reportingYrList: any;
  tmssloader: any;
  xtosDelinqReport: FormGroup;
  resultsSubscription = new Subscription();
  rowData: any;
  columnsDefs: any;
  private gridApi!: GridApi<any>;
  gridColumnApi;
  hhDelinqReport4thQuarter;
  modalRef: BsModalRef;
  showDelinqMessage: Boolean;
  qtrList: any = [{
    "value": -1,
    "name": "All Quarters"
  },{
    "value": 1,
    "name": "Quarter 1 (January - March)"
  },
    {
      "value": 2,
      "name": "Quarter 2 (April - June)"
    },
    {
      "value": 3,
      "name": "Quarter 3 (July - September)"
    },
    {
      "value": 4,
      "name": "Quarter 4 (October - December)"
    }];

  printQtrList:any =[];

  toolTipValueGetter = function (params: any) {
    return {value: params.value};
  };
  curdate: string;
  curMonth: number;
  curYear: number;
  curQtr: number;

  constructor(
    private delinquentService: DelinquencyReportService,
    public loader: LoadingService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private fb: FormBuilder
  ) {
    this.hhDelinqReport4thQuarter = this.getColumnDef(0);
  }

  ngOnInit() {
    this.tmssloader = this.loader;
    this.tmssloader.show();
    this.populateDelinqYear();
    this.populateDelinqReportFormGroup();
    this.tmssloader.hide();
    this.generateListofQtr();
  }

  getLastDayOfQuarterMonth(date: any) {
    let retVal = moment(date, "MM-DD-YYYY").endOf('quarter').toDate();
    return retVal;
  }

  generateListofQtr() {
    this.printQtrList = [];
    const curYear = new Date().getFullYear();
    const inputYear = Number(this.xtosDelinqReport.get('reportingYrSelect').value);
    if (curYear === inputYear) {
      const currQtr = moment().quarter();
      var currDate = new Date();

      if (currQtr === 1) { this.qtrList = null; }
      if (currQtr === 2) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('01-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value === 1);
        }
      }
      if (currQtr === 3) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('06-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 3);
        } else
          this.printQtrList = this.qtrList.filter(qtr => qtr.value === 1);
      }

      if (currQtr === 4) {
        const lastQtrDate = this.getLastDayOfQuarterMonth('09-01-' + curYear);
        if (moment(currDate).diff(moment(lastQtrDate), 'days') > 60) {
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 4);
        } else
          this.printQtrList = this.qtrList.filter(qtr => qtr.value < 3);
      }
    } else {
      if (curYear === inputYear - 1) {
        const currQtr = moment().quarter();
        if (currQtr === 1) {
          const currDate = new Date();
          const lastQtrDate = this.getLastDayOfQuarterMonth('09-01-' + inputYear);
          if (moment(lastQtrDate).diff(moment(currDate), 'days') < 60) {
            this.printQtrList = this.qtrList.filter(qtr => qtr.value < 4);
          }else
            this.printQtrList = this.qtrList;
        }
      }else
        this.printQtrList = this.qtrList;
    }
    console.log(this.printQtrList);
  }

  populateDelinqReportFormGroup() {
    this.xtosDelinqReport = this.fb.group({
      reportingYrSelect: new FormControl('', Validators.required),
      reportingQtrSelect: new FormControl('', Validators.required)
    });
  }

  populateDelinqYear() {
    this.tmssloader.show();
    this.delinquentService.getXtosDelinqYearViewOnly().subscribe(yearList => {
      this.reportingYrList = yearList.reverse();
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving year list');
    });
  }

  getXTOSDelinqReport() {
    this.loader.show();
    this.resultsSubscription = this.delinquentService.getXtosDelinqReportViewOnly(Number(this.xtosDelinqReport.value.reportingYrSelect), Number(this.xtosDelinqReport.value.reportingQtrSelect),'XTOS').subscribe(res => {
      if (res !== null && res !== undefined && res.length > 0) {
        this.rowData = CommonHelpers.sortAtoZ(res);
        if(Number(this.xtosDelinqReport.value.reportingQtrSelect) === -1){
          this.gridApi.setGridOption('columnDefs', this.getColumnDef(-1));
        }else{
          this.gridApi.setGridOption('columnDefs', this.getColumnDef(0));
        }
        const rptQtr = Number(this.xtosDelinqReport.value.reportingQtrSelect);
        const carrierRoles = AppConstants.OnlyDenlAndPend();
        switch(rptQtr) {
          case 1:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last1stQuarterCCESStatus) || carrierRoles.includes(v.last1stQuarterBESStatus))
            );
            break;
          case 2:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last2ndQuarterCCESStatus) || carrierRoles.includes(v.last2ndQuarterBESStatus))
            );
            break;
          case 3:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last3rdQuarterCCESStatus) || carrierRoles.includes(v.last3rdQuarterBESStatus))
            );
            break;
          case 4:
            this.rowData= res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last4thQuarterCCESStatus) || carrierRoles.includes(v.last4thQuarterBESStatus))
            );
            break;
          case -1:
            this.rowData = res.filter(
              (v:any) =>
                (carrierRoles.includes(v.last1stQuarterCCESStatus) || carrierRoles.includes(v.last1stQuarterBESStatus)) ||
                (carrierRoles.includes(v.last2ndQuarterCCESStatus) || carrierRoles.includes(v.last2ndQuarterBESStatus)) ||
                (carrierRoles.includes(v.last3rdQuarterCCESStatus) || carrierRoles.includes(v.last3rdQuarterBESStatus)) ||
                (carrierRoles.includes(v.last4thQuarterCCESStatus) || carrierRoles.includes(v.last4thQuarterBESStatus))

            );
          default:
            break;
        }
        this.gridApi.setGridOption('datasource', this.rowData);
        this.loader.hide();
      } else {
        this.rowData = null;
        this.loader.hide();
      }
    });
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridApi.setGridOption('datasource', this.rowData);
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridOptions: GridOptions = {
    rowSelection: 'multiple',
    defaultColDef: {
      sortable: true,
      resizable: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        suppressAndOrCondition: false
      }
    },
    pagination: true,
    paginationPageSize: 10,
    cacheBlockSize: 25,
    headerHeight: 50,
    domLayout: 'autoHeight',
    suppressDragLeaveHidesColumns: true,

    overlayLoadingTemplate:
      '<span class="ag-overlay-loading-center">Select the Reporting Year/Quarter to load report.</span>',
    overlayNoRowsTemplate:
      '<span>No results found. Please adjust your filters.</span>'
  };

  getColumnDef(quarter:number) {
    if(quarter === 0){
      return [
        {
          colId: 'scac',
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true
        },
        {
          colId: 'last4thQuarter',
          headerValueGetter: () => {
            const tempq = Number(this.xtosDelinqReport.value.reportingQtrSelect);
            return (tempq === 4) ? this.xtosDelinqReport.value.reportingYrSelect + ' 4th Quarter' :
              (tempq === 3) ? this.xtosDelinqReport.value.reportingYrSelect + ' 3rd Quarter' :
                (tempq === 2) ? this.xtosDelinqReport.value.reportingYrSelect +' 2nd Quarter' : this.xtosDelinqReport.value.reportingYrSelect + ' 1st Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'CCES',
              valueGetter: (params) => {
                const tempq = Number(this.xtosDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterCCESStatus :
                  (tempq === 3) ? params.data.last3rdQuarterCCESStatus :
                    (tempq === 2) ? params.data.last2ndQuarterCCESStatus : params.data.last1stQuarterCCESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'BES',
              valueGetter: (params) => {
                const tempq = Number(this.xtosDelinqReport.value.reportingQtrSelect);
                return (tempq === 4) ? params.data.last4thQuarterBESStatus :
                  (tempq === 3) ? params.data.last3rdQuarterBESStatus :
                    (tempq === 2) ? params.data.last2ndQuarterBESStatus : params.data.last1stQuarterBESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: 'POC Contact',
          marryChildren: true,
          headerName: 'POC Contact',
          children: [
            {
              headerName: 'Full Name',
              valueGetter: (params) => {
                return params.data.pocFirstName + ' ' + params.data.pocLastName;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'Email',
              valueGetter: (params) => {
                return (params.data.email.length > 0) ? params.data.email.toLowerCase() : 'Not Available';
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        }
      ];
    }else{

      return [
        {
          colId: 'scac',
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true
        },
        {
          colId: '1stQuarter',
          headerValueGetter:  () => {
            return this.xtosDelinqReport.value.reportingYrSelect + ' 1st Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'CCES',
              valueGetter: (params) => {
                return params.data.last1stQuarterCCESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'BES',
              valueGetter: (params) => {
                return params.data.last1stQuarterBESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '2nd Quarter',
          headerValueGetter:  () => {
            return this.xtosDelinqReport.value.reportingYrSelect + ' 2nd Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'CCES',
              valueGetter: (params) => {
                return params.data.last2ndQuarterCCESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'BES',
              valueGetter: (params) => {
                return params.data.last2ndQuarterBESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '3rd Quarter',
          headerValueGetter:  () => {
            return this.xtosDelinqReport.value.reportingYrSelect + ' 3rd Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'CCES',
              valueGetter: (params) => {
                return params.data.last3rdQuarterCCESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'BES',
              valueGetter: (params) => {
                return params.data.last3rdQuarterBESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: '4th Quarter',
          headerValueGetter: () => {
            return  this.xtosDelinqReport.value.reportingYrSelect + ' 4th Quarter';

          },
          marryChildren: true,
          children: [
            {
              headerName: 'CCES',
              valueGetter: (params) => {
                return params.data.last4thQuarterCCESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'BES',
              valueGetter: (params) => {
                return params.data.last4thQuarterBESStatus;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        },
        {
          colId: 'POC Contact',
          marryChildren: true,
          headerName: 'POC Contact',
          children: [
            {
              headerName: 'Full Name',
              valueGetter: (params) => {
                return params.data.pocFirstName + ' ' + params.data.pocLastName;
              },
              filter: 'agTextColumnFilter',
              sortable: true
            },
            {
              headerName: 'Email',
              valueGetter: (params) => {
                return (params.data.email.length > 0) ? params.data.email.toLowerCase() : 'Not Available';
              },
              filter: 'agTextColumnFilter',
              sortable: true
            }
          ]
        }
      ];

    }

  }

  defaultColDef = {
    tooltipComponent: 'cellRenderer',
    tooltipValueGetter: this.toolTipValueGetter
  };
  tooltipShowDelay = 0;
  frameworkComponents = {
    cellRenderer: CellRenderer,
    iconRenderer: IconRenderer
  };

}
